import ReferralVM from './referrals-vm';
import Vue from 'vue';

export default {
  init: function (element) {
    Kadenze.Share.init();
    let vm = new Vue(ReferralVM);
    vm.$mount(element);
  }
};
